import React, { useEffect, useState } from 'react';
import { wsGet } from 'services/WService';

export default function Xml(props) {
  const [xmlUrl, setXmlUrl] = useState();

  const { showNotify, purchase } = props;
  const [error, setError] = useState(false);

  async function getXml(){
    let response = await wsGet(`purch/purchase/${purchase.id}/xml`);
    setXmlUrl(response.data);
  }

  useEffect(() => {
    if(purchase.xml_path === null){
      showNotify('La compra no tiene xml', 'warning');
      setError(true);
      return;
    }

    getXml();
  }, [purchase]);

  return props.Url !== null ? (
    <>
      <a href={xmlUrl} download target='__blank'>Descargar</a>
      <iframe
        src={xmlUrl}
        height="1200" width="100%"
        className="text"
      >
        No se pudo cargar el contenido.
      </iframe>
    </>
  ) : (
    <div>
      <h3>No hay XML cargado</h3>
    </div>
  );
}
